import React from 'react';
import { Image, Box } from '@qga/roo-ui/components';
import pin from './Google_Maps_pin.svg';

const PIN_WIDTH = 27;
const PIN_HEIGHT = 43;

const GoogleMapMarker = () => (
  <Box position="absolute" top={`-${PIN_HEIGHT}px`} left={`-${Math.ceil(PIN_WIDTH / 2)}px`} data-testid="google-map-marker">
    <Image height={`${PIN_HEIGHT}px`} width={`${PIN_WIDTH}px`} src={pin} alt="location marker" />
  </Box>
);

export default GoogleMapMarker;
